import client from './client';

/**
 * Agent metadata API (Phase 5)
 * Public endpoints - no auth required.
 */

export const getAgentVersion = () => {
  console.log('[agent] version');
  return client.get('/api/agent/version');
};

export const getAgentDownloads = () => {
  console.log('[agent] download');
  return client.get('/api/agent/download');
};
